import { put } from 'redux-saga/effects';

import { CustomAchievementsActions } from '@maggie/store/custom-achievements/actions';

export function* handleDidNavigateToProfile() {
  yield put(CustomAchievementsActions.fetchCustomAchievementsList());
}
